import { supabase } from '../supabaseClient';

export const executiveFormationService = {
  async getSettings(editionYear) {
    try {
      const { data: edition } = await supabase
        .from('editions')
        .select('id, year')
        .eq('year', editionYear)
        .single();

      if (!edition) throw new Error(`Edition ${editionYear} not found`);

      const { data: settings, error } = await supabase
        .from('executive_settings')
        .select('*')
        .eq('edition_id', edition.id)
        .single();

      if (error && error.code !== 'PGRST116') throw error;

      return settings || {
        hero_title: 'Formations Executive & Certifications',
        hero_subtitle: 'Développez vos compétences avec nos programmes d\'excellence executive',
        intro_text: 'Nos formations executive combinent expertise académique et compétences pratiques.',
        is_visible: true,
        edition_id: edition.id
      };
    } catch (error) {
      console.error('Error getting executive settings:', error);
      throw error;
    }
  },

  async updateSettings(settings) {
    try {
      const { id, created_at, updated_at, ...updateData } = settings;
      
      // Convert boolean to integer for MySQL compatibility
      if (typeof updateData.is_visible === 'boolean') {
        updateData.is_visible = updateData.is_visible ? 1 : 0;
      }
      
      if (id) {
        const { error } = await supabase
          .from('executive_settings')
          .update({ ...updateData, updated_at: new Date().toISOString() })
          .eq('id', id);
        if (error) throw error;
      } else {
        const { error } = await supabase
          .from('executive_settings')
          .insert([updateData]);
        if (error) throw error;
      }
    } catch (error) {
      console.error('Error updating executive settings:', error);
      throw error;
    }
  },

  async getCertificates(editionYear) {
    try {
      const { data: edition } = await supabase
        .from('editions')
        .select('id')
        .eq('year', editionYear)
        .single();

      if (!edition) throw new Error(`Edition ${editionYear} not found`);

      const { data, error } = await supabase
        .from('executive_certificates')
        .select('*')
        .eq('edition_id', edition.id)
        .order('display_order', { ascending: true });

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error getting executive certificates:', error);
      throw error;
    }
  },

  async saveCertificate(certificate) {
    try {
      const { id, created_at, updated_at, ...data } = certificate;
      
      // Convert boolean to integer for MySQL compatibility
      if (typeof data.is_active === 'boolean') {
        data.is_active = data.is_active ? 1 : 0;
      }
      
      if (id) {
        const { error } = await supabase
          .from('executive_certificates')
          .update({ ...data, updated_at: new Date().toISOString() })
          .eq('id', id);
        if (error) throw error;
      } else {
        const { error } = await supabase
          .from('executive_certificates')
          .insert([data]);
        if (error) throw error;
      }
    } catch (error) {
      console.error('Error saving certificate:', error);
      throw error;
    }
  },

  async deleteCertificate(id) {
    try {
      const { error } = await supabase
        .from('executive_certificates')
        .delete()
        .eq('id', id);
      if (error) throw error;
    } catch (error) {
      console.error('Error deleting certificate:', error);
      throw error;
    }
  },

  async registerExecutive(registration) {
    try {
      const { error } = await supabase
        .from('executive_registrations')
        .insert([registration]);
      if (error) throw error;
    } catch (error) {
      console.error('Error submitting executive registration:', error);
      throw error;
    }
  },

  async getRegistrations(editionYear) {
    try {
      const { data: edition } = await supabase
        .from('editions')
        .select('id')
        .eq('year', editionYear)
        .single();

      if (!edition) throw new Error(`Edition ${editionYear} not found`);

      const { data, error } = await supabase
        .from('executive_registrations')
        .select('*')
        .eq('edition_id', edition.id)
        .order('created_at', { ascending: false });

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error getting executive registrations:', error);
      throw error;
    }
  },

  async deleteRegistration(id) {
    try {
      const { error } = await supabase
        .from('executive_registrations')
        .delete()
        .eq('id', id);
      if (error) throw error;
    } catch (error) {
      console.error('Error deleting executive registration:', error);
      throw error;
    }
  }
};
